import { cn } from "utils";

export function TimesheetHeader({ children, className }) {
  return (
    <div
      className={cn(
        "flex justify-between md:items-start md:gap-6 gap-4 md:flex-row flex-col lg:py-5 py-4 lg:px-6 px-4  ",
        className
      )}
    >
      {children}
    </div>
  );
}

export function TimesheetHeaderTitle({ children, className }) {
  return (
    <h2 className={cn("text-2xl font-semibold", className)}>{children}</h2>
  );
}
